<nav
    class="flex items-center justify-around border-t border-gray-200 bg-white px-2 pt-1 pb-[calc(0.25rem+var(--safe-area-bottom))] shadow-lg dark:border-gray-700 dark:bg-gray-900">
    @for (item of items; track $index) {
        <a
            [routerLink]="item.routerLink"
            routerLinkActive="bg-primary-50 text-primary"
            #rla="routerLinkActive"
            class="flex flex-col items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium transition-all duration-200"
            [class.bg-primary-50]="rla.isActive"
            [class.text-primary]="rla.isActive"
            [class.text-gray-400]="!rla.isActive"
            [class.shadow-sm]="rla.isActive">
            <i
                class="pi {{
                    item.icon
                }} text-base transition-colors duration-200"
                [class.!text-primary]="rla.isActive"></i>
            <span>{{ item.label }}</span>
        </a>
    }
</nav>
